import { render, staticRenderFns } from "./MultiButton.vue?vue&type=template&id=72d91e7a&"
import script from "./MultiButton.vue?vue&type=script&lang=js&"
export * from "./MultiButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports